import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

/**
 * Admin Console Entry Point
 * Redirects to /admin/platform/users (Platform Users page)
 */
const AdminConsoleMain = ({ auth }) => {
  const history = useHistory();

  useEffect(() => {
    if (auth === null || auth === undefined) return;
    if (auth === false) {
      history.push('/');
      return;
    }
    if (!auth.id || (auth.platform_role !== 'super_admin' && auth.platform_role !== 'admin')) {
      history.push('/');
      return;
    }
    // Redirect to platform users page
    history.push('/admin/platform/users');
  }, [auth, history]);

  return null;
};

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(AdminConsoleMain);
